import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_4 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_5 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " TOTAL MONTHLY INCOME $", -1)
const _hoisted_7 = { class: "tw-px-4" }
const _hoisted_8 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_9 = { class: "tw-items-center tw-gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " TOTAL MONTHLY INCOME $: ", -1)
const _hoisted_11 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3 d-flex align-items-center justify-contetn-center" }
const _hoisted_12 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " ESTIMATED MORTGAGE", -1)
const _hoisted_14 = { class: "tw-px-4 d-flex flex-column align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-[15px] tw-p-[10px] d-block mt-3" }, "MORTGAGE ESTIMATED MORTGAGE LOAN")
], -1)
const _hoisted_16 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-[35px] tw-mb-[35px] tw-gap-[50px]" }
const _hoisted_17 = { class: "tw-items-center tw-gap-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, " RESULT: ", -1)
const _hoisted_19 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3 d-flex align-items-center justify-contetn-center" }

import axios from 'axios';
import { ref, watch, computed } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";
import { currencyFormat } from '@/composables/filters';

//COMPONENTS
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";
import DTIFinancingInformation from '@/components/admin/Residential/DTIFinancingInformation/DTIFinancingInformation.vue';
import FamilyMonthlyExpenses from '@/components/admin/Residential/DTIFinancingInformation/FamilyMonthlyExpenses.vue';

import { useToast } from "@/composables/useToast";
import SheetDTIRatio from '../economicSheet/SheetDTIRatio.vue';
const scenarioValid = false


export default /*#__PURE__*/_defineComponent({
  __name: 'DTIRatio',
  setup(__props) {

const toast = useToast();

//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const userSession = ref(null)
const selectedMLO = ref(null)
const selectedCompanyTitle = ref({ data: null})
const selectedInspector = ref({ data: null})
const customer = ref({
  name: '',
  phone: '',
  email: ''
})
const financialInformation = ref({
  customers: [{
    hourlyIncome: [{
      paymentForHour: 0,
      hoursForWeek: 0,
      daysForWeek: 0,
      weeksForMonth: 0,
      monthsForYear: 0,
      monthlyIncome: 0,
    }],
    weeklyIncome: [{
      paymentForWeek: 0,
      weeksForMonth: 0,
      monthsForYear: 0,
      monthlyIncome: 0
    }],
    biweekyIncome: [{
      paymentForWeekly: 0,
      byWeeklyForYear: 0,
      monthsForYear: 0,
      monthlyIncome: 0
    }],
    monthlyIncome: [{
      paymentForMonths: 0,
      monthsForYear: 0,
      monthlyIncome: 0,
    }],
    totalMonthlyIncome: 0,
  }],
  totalCustomerMonthlyIncome: 0,
  familyHousingExpenses: {},
  totalFamilyHousingExpenses: {
    total: 0
  },
  propertyEstimatedMortgage: 0,
})

const totalAllCustomers = computed(() => {
  return financialInformation.value.customers.reduce((sum, customer) => {
    return sum + (customer.totalMonthlyIncome || 0);
  }, 0);
});

watch(totalAllCustomers, (newTotal) => {
  financialInformation.value.totalCustomerMonthlyIncome = newTotal;
});

const sortOutRatio = computed(() => {
  let interest_rate = 0;
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
  }
  return Math.pow(1 + ((interest_rate / 12) / 100), years) * ((interest_rate / 12) / 100);
})

const sortOutRatio2 = computed(() => {
  let interest_rate = 0;
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
    result = Math.pow(1 + (interest_rate / 12) / 100, years) - 1
  }
  return result
})

const sortOutFactor = computed(() => {
  let result = 0
  if (sortOutRatio.value !== 0 && sortOutRatio2.value !== 0) {
    result = sortOutRatio.value / sortOutRatio2.value
  }
  return result
})

watch(
  [
    () => financialInformation.value.totalCustomerMonthlyIncome,
    () => financialInformation.value.totalFamilyHousingExpenses.total
  ],
  (value) => {
    console.log("sort out", sortOutFactor.value)
    console.log("sort out 1", sortOutRatio.value)
    console.log("sort out 2", sortOutRatio2.value)
    

    let monthlyTotal = financialInformation.value.totalCustomerMonthlyIncome
    let totalExpenses = financialInformation.value.totalFamilyHousingExpenses.total
    let backend_ratio = selectedMLO.value !== null ? selectedMLO.value.backEndRatio : 0
    let DTIValue = monthlyTotal * (backend_ratio / 100)
    let DTIValueNet = DTIValue - totalExpenses
    const result = DTIValueNet / sortOutFactor.value
    financialInformation.value.propertyEstimatedMortgage = result > 0 ? result : 0
  },
  {
    immediate: true // Will run immediately when watcher is created
  }
)

const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
}
getSession();

const getData = async () => {
  loading.value = true;
}

const submitScenario = async () => {
  loading.value = true;
  const response = await axios(`${url}realtor-dti-ratio`, {
    method: "POST",
    data: {
      realtorDti: [{
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "DTI RATIO",
        loanProgram: selectedMLO.value.filters.program,
        loanYears:selectedMLO.value.filters.year,
        interestRate:  selectedMLO.value.interestRate,
        //hourlyIncome:financialInformation.value.customers.hourlyIncome.monthlyIncome,
        // weeklyIncome: financialInformation.customers.weeklyIncome.monthlyIncome,
        // biweekyIncome:financialInformation.customers.biweekyIncome.monthlyIncome,
        // monthlyIncome:financialInformation.customers.monthlyIncome.monthlyIncome,
        // totalMonthlyIncome: financialInformation.value.customers.totalCustomerMonthlyIncome,
        // estimatedMortgage: financialInformation.value.customers.propertyEstimatedMortgage
      }],
      customer: {
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "DTI RATIO",
        name: customer.value.name,
        phone: customer.value.phone,
        email: customer.value.email
      },
      mloSelected: {
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "DTI RATIO",
        name: selectedMLO.value.realtorMLOData.name,
        lastname: selectedMLO.value.realtorMLOData.lastname,
        phone: selectedMLO.value.realtorMLOData.phone,
        email: selectedMLO.value.realtorMLOData.email,
        program: selectedMLO.value.filters.program,
        interestRate: selectedMLO.value.interestRate,
        minimumDownPayment: selectedMLO.value.minimumDownPayment,
        pmi: selectedMLO.value.PMI,
        backEndRatio: selectedMLO.value.backEndRatio,
        maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
        client_name: customer.value.name,
        client_email: customer.value.email
      },
    }
  });

  if (!response.data.error) {
    loading.value = false;
    getData()
    await toast.success(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } else {
    loading.value = false;
    await toast.error(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial for the use of the ''DTI RATIO''",
      helpVideo: "https://www.realtortools.org/media/VideoDtiRatio.mp4"
    }),
    _createElementVNode("div", null, [
      _createVNode(ResidentialView, { header: false })
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(FindA, {
        userSession: userSession.value,
        usingCompanyTitle: selectedCompanyTitle.value,
        usingInspector: selectedInspector.value
      }, null, 8, ["userSession", "usingCompanyTitle", "usingInspector"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(MLO, {
          userSession: userSession.value,
          usingMLO: selectedMLO.value,
          "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
          customer: customer.value
        }, null, 8, ["userSession", "usingMLO", "customer"]),
        _createVNode(DTIFinancingInformation, {
          selectedMLO: selectedMLO.value,
          customersData: financialInformation.value.customers
        }, null, 8, ["selectedMLO", "customersData"]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(currencyFormat)(financialInformation.value.totalCustomerMonthlyIncome)), 1)
              ])
            ])
          ])
        ]),
        _createVNode(FamilyMonthlyExpenses, {
          selectedMLO: selectedMLO.value,
          familyHousingExpenses: financialInformation.value.familyHousingExpenses,
          totalFamilyHousingExpenses: financialInformation.value.totalFamilyHousingExpenses
        }, null, 8, ["selectedMLO", "familyHousingExpenses", "totalFamilyHousingExpenses"]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(currencyFormat)(financialInformation.value.propertyEstimatedMortgage)), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})